export const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'croatian',
    locale: 'hr',
    name: 'Hrvatski',
    icon: 'hr',
  },
  {
    languageId: 'serbian',
    locale: 'sr',
    name: 'Srpski',
    icon: 'sr',
  },
  /*{
    languageId: 'german',
    locale: 'de',
    name: 'Deutch',
    icon: 'de',
  },

  {
    languageId: 'italian',
    locale: 'it',
    name: 'Italiano',
    icon: 'it',
  },
  {
    languageId: 'slovenian',
    locale: 'sl',
    name: 'Slovenščina',
    icon: 'sl',
  },*/
];

export const flags = {
  en: '/images/flag/icons8-usa.png',
  hr: '/images/flag/icons8-croatia.png',
  sr: '/images/flag/icons8-serbia.png',
};
